<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-col class="image-item" v-for="(item,index) in config[field.key]" :key="index">
                <el-row>
                    <el-input clearable v-model="config[field.key][index]['name']" size="small"></el-input>
                </el-row>
                <el-row type="flex">
                    <el-col class="col-left">
                        <label>普通状态</label>
                        <image-uploader :currentIndex="index"
                                        :uploadedImg="config[field.key][index]['unselected_icon']"
                                        @uploaded="handleUploadUnSelected"></image-uploader>
                    </el-col>
                    <el-col class="col-right">
                        <label>选中状态（可选）</label>
                        <image-uploader :currentIndex="index"
                                        :uploadedImg="config[field.key][index]['selected_icon']"
                                        @uploaded="handleUploadSelected"></image-uploader>
                    </el-col>
                </el-row>
                <el-row>
                    建议尺寸：81px*81px
                </el-row>
                <el-row>
                    <div>
                        <span class="link-name" v-text="config[field.key][index]['link_name']"></span>
                    </div>
                    <el-button size="mini" @click="openDialog(index)"
                               v-text="config[field.key][index]['link_name'] ? '更换链接' : '请选择链接'" style="margin-right: 10px;"></el-button>
                    <el-button v-if="config[field.key][index]['link_name']" size="mini" class="clear-link"
                               @click="clearLink(index)" style="margin-left: 0px;">清除链接
                    </el-button>
                </el-row>
                <i class="el-icon-circle-close-outline" @click="removeImageItem(index)"></i>
            </el-col>
            <el-button size="mini" @click="addImageItem()">添加导航</el-button>
        </el-form-item>
        <!-- 店铺地址对话框 -->
        <el-dialog title="请选择链接" :visible.sync="dialog.visible" @close='closeDialog'>
            <helper @select="select" @close='closeDialog'></helper>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .image-item {
        position: relative;
        border: 1px solid #E3E7EE;
        background-color: #F9F9F9;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 20px;
        .col-left {
            flex: 0 0 150px;
        }
        .col-right {
            flex: 0 0 150px;
            .link-name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100px;
                padding-right: 10px;
            }
        }
        .el-icon-circle-close-outline {
            font-size: 18px;
            position: absolute;
            top: -9px;
            right: -9px;
            background: #FFF;
            cursor: pointer;
        }
    }

</style>

<script>

  import ImageUploader from '@/components/ImageUploader.vue';

  export default {
    name: 'tms-type-bottom-nav',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        currentIndex: 0
      }
    },

    components: {
      ImageUploader
    },

    mounted() {

    },

    methods: {
      clearLink(index) {
        delete this.config[this.field.key][index].link_name;
        delete this.config[this.field.key][index].link_data;
        delete this.config[this.field.key][index].link_type;
        let temp = this.config[this.field.key][index];
        this.config[this.field.key].splice(index,1,temp);
      },
      addImageItem() {
        if (this.config[this.field.key].length < 5) {
          this.config[this.field.key].push({
            selected_icon: '',
            name: '导航' + (this.config[this.field.key].length + 1),
            link_type: 5,
            link_data: ''
          })
        }
      },
      removeImageItem(index) {
        this.config[this.field.key].splice(index, 1);
      },
      handleUploadSelected(src, index) {
        this.$set(this.config[this.field.key][index], 'selected_icon', src);
      },
      handleUploadUnSelected(src, index) {
        this.$set(this.config[this.field.key][index], 'unselected_icon', src);
      },
      openDialog(index) {
        this.currentIndex = index;
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(link, linkName, linkType) {
        this.config[this.field.key][this.currentIndex].link_name = linkName;
        this.config[this.field.key][this.currentIndex].link_data = link;
        this.config[this.field.key][this.currentIndex].link_type = linkType;
        this.dialog.visible = false;
      }
    }
  }

</script>
